import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { reactPlugin } from './appInsights';
import './index.css';
import Euro2024 from './pages/euro2024/Euro2024';
import HouseholdBoard from './pages/household/HouseholdBoard';
import WC26Admin from './pages/wc26admin/WC26Admin';
import WC26Bracket from './pages/wc26bracket/WC26Bracket';
import WC26UserPage from './pages/wc26user/WC26UserPage';
import WorldCup2026 from './pages/worldcup2026/WorldCup2026';
import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/wc26" replace />,
  },
  {
    path: '/wc26',
    element: <WorldCup2026 />,
  },
  {
    path: '/euro2024',
    element: <Euro2024 />,
  },
  {
    path: '/wc26-admin',
    element: <WC26Admin />,
  },
  {
    path: '/wc26-bracket',
    element: <WC26Bracket />,
  },
  {
    path: '/wc26-user/:name',
    element: <WC26UserPage />,
  },
  {
    path: '/household',
    element: <HouseholdBoard />,
  },
  {
    path: '*',
    element: <Navigate to="/wc26" replace />,
  }
]);

const rootElement = document.getElementById('root') as HTMLElement;
rootElement.className = 'root';

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AppInsightsContext.Provider value={reactPlugin}>
      <RouterProvider router={router} />
    </AppInsightsContext.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
